export default "__VITE_ASSET__BOZK6Ngu__"